module.exports = __webpack_public_path__ + "static/img/17032A_1_2_C_20210208_LC.3ee824d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17032A_1_2_C_20210208_LC.png
// module id = 23wB
// module chunks = 0